import React from 'react';
import '../../search/assets/css/date-search.css';
import './assets/css/search_fields.css';

const ShimmerItem = ({ className = '' }) => (
  <div className={`list-item ${className}`} style={{ opacity: 0.6 }}>
    <div
      className='sb-blue-bg-100'
      style={{
        padding: 8,
        borderRadius: 8,
        marginRight: 12,
        width: 40,
        height: 40,
        textAlign: 'center',
        background:
          'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.5s infinite',
      }}
    />
    <div className='text' style={{ flex: 1 }}>
      <div
        className='main'
        style={{
          height: 16,
          background:
            'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
          backgroundSize: '200% 100%',
          animation: 'shimmer 1.5s infinite',
          borderRadius: 4,
          marginBottom: 4,
        }}
      />
      <div
        style={{
          height: 12,
          width: '70%',
          background:
            'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
          backgroundSize: '200% 100%',
          animation: 'shimmer 1.5s infinite',
          borderRadius: 4,
        }}
      />
    </div>
  </div>
);

export default ShimmerItem;
